import { useCallback, useEffect, useState } from "react";
import { api, mesajEroare } from "./api.js";
import { data } from "./text.js";
import { tr } from "./i18n.js";

const INCARCARE = ["ADMIN_TENANT", "MANAGER_TEHNIC", "DISPECER", "COORDONATOR"];

const marime = (o) => (o == null ? "—" : o < 1024 ? `${o} B`
  : o < 1024 * 1024 ? `${(o / 1024).toFixed(0)} KB` : `${(o / 1024 / 1024).toFixed(1)} MB`);

export default function Documente({ eu }) {
  const [clienti, setClienti] = useState([]);
  const [clientId, setClientId] = useState("");
  const [rubrici, setRubrici] = useState([]);
  const [rubrica, setRubrica] = useState("");
  const [lista, setLista] = useState([]);
  const [toateVersiunile, setToateVersiunile] = useState(false);
  const [depozit, setDepozit] = useState(null);
  const [form, setForm] = useState(null);
  const [istoric, setIstoric] = useState(null);
  const [incarca, setIncarca] = useState(false);
  const [eroare, setEroare] = useState("");

  const poateIncarca = INCARCARE.includes(eu.rol);

  useEffect(() => {
    api.clienti().then((l) => { setClienti(l); if (l.length === 1) setClientId(l[0].id); })
      .catch((e) => setEroare(mesajEroare(e)));
    api.rubriciDocument().then(setRubrici).catch((e) => setEroare(mesajEroare(e)));
    api.stareDepozit().then(setDepozit).catch(() => {});
  }, []);

  const reincarca = useCallback(async () => {
    if (!clientId) { setLista([]); return; }
    setIncarca(true);
    try {
      setLista(await api.documente(clientId, { categorie: rubrica || undefined, toateVersiunile }));
    } catch (e) { setEroare(mesajEroare(e)); }
    finally { setIncarca(false); }
  }, [clientId, rubrica, toateVersiunile]);

  useEffect(() => { reincarca(); }, [reincarca]);

  const descarca = async (d) => {
    try { await api.descarcaDocument(d.id, d.denumire); }
    catch (e) { setEroare(mesajEroare(e)); }
  };

  return (
    <div className="continut">
      <h1>{tr("Dosarul tehnic")}</h1>
      <p className="subtitlu">
        {tr("Proiecte, scheme, as-built, manuale, certificate, avize. Nimic nu se suprascrie: o versiune nouă o lasă pe cea veche la locul ei.")}
      </p>

      {eroare && <div className="eroare">{eroare}</div>}

      {depozit && !depozit.configurat && (
        <div className="panou panou-atentie">
          <div className="panou-corp">
            <strong>{tr("Depozitul de fișiere nu e configurat pe acest server.")}</strong>{" "}
            {tr("Rubricile, versionarea și drepturile funcționează, dar încărcarea propriu-zisă va fi refuzată — aplicația nu se preface că a salvat. Se rezolvă adăugând cheile depozitului în configurația serverului.")}
          </div>
        </div>
      )}

      <div className="panou">
        <div className="panou-corp">
          <div className="formular-linie">
            <label>{tr("Client")}
              <select className="camp" value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">{tr("— alege clientul —")}</option>
                {clienti.map((c) => <option key={c.id} value={c.id}>{tr(c.denumire)}</option>)}
              </select>
            </label>
            <label>{tr("Rubrică")}
              <select className="camp" value={rubrica} onChange={(e) => setRubrica(e.target.value)}>
                <option value="">{tr("toate rubricile")}</option>
                {rubrici.map((r) => (
                  <option key={r.id} value={r.id}>
                    {tr(r.denumire)}{r.generatDeAplicatie ? tr(" (generată)") : ""}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="linie-actiune" style={{ alignItems: "center" }}>
            <label className="comutator-dezactivate">
              <input type="checkbox" checked={toateVersiunile}
                onChange={(e) => setToateVersiunile(e.target.checked)} />
              {tr("arată și versiunile vechi")}
            </label>
            {poateIncarca && clientId && (
              <button className="buton buton-actiune" onClick={() => setForm({ inlocuieste: null })}>
                {tr("document nou")}
              </button>
            )}
          </div>
        </div>
      </div>

      {!clientId ? (
        <div className="panou"><div className="panou-corp gol">
          {tr("Alege un client ca să-i vezi dosarul.")}
        </div></div>
      ) : incarca ? (
        <div className="gol" style={{ padding: "2rem 0" }}>{tr("Se încarcă…")}</div>
      ) : lista.length === 0 ? (
        <div className="panou"><div className="panou-corp gol">
          {tr("Niciun document")} {rubrica ? tr("în rubrica aleasă") : tr("încă")}.
        </div></div>
      ) : (
        <div className="panou">
          <div className="panou-antet">
            <h2>{tr("Documente")}</h2><span className="numar">{lista.length}</span>
          </div>
          <div className="panou-corp">
            <table className="tabel">
              <thead>
                <tr><th>{tr("Document")}</th><th>{tr("Rubrică")}</th><th>{tr("Atașat la")}</th><th>{tr("Versiune")}</th>
                    <th>{tr("Mărime")}</th><th>{tr("Client")}</th><th></th></tr>
              </thead>
              <tbody>
                {lista.map((d) => (
                  <tr key={d.id} className={d.esteCurenta ? "" : "tip-dezactivat"}>
                    <td className="tip-denumire">
                      {tr(d.denumire)}
                      {!d.esteCurenta && <span className="eticheta eticheta-inactiv">{tr("versiune veche")}</span>}
                    </td>
                    <td>{tr(d.categorie.denumire)}</td>
                    <td>
                      {d.echipament ? `echipament ${d.echipament.eticheta || d.echipament.codQR}`
                        : d.sistemInstalat ? d.sistemInstalat.denumire
                        : d.locatie ? d.locatie.denumire
                        : <span className="fara-pret">{tr("întreaga firmă")}</span>}
                    </td>
                    <td className="num">
                      {tr("v")}{d.versiune}
                      {d.versiune > 1 && (
                        <button className="buton-mic" style={{ marginLeft: ".4rem" }}
                          onClick={async () => {
                            try { setIstoric(await api.versiuniDocument(d.id)); }
                            catch (e) { setEroare(mesajEroare(e)); }
                          }}>{tr("istoric")}</button>
                      )}
                    </td>
                    <td className="num">{marime(d.dimensiune)}</td>
                    <td>
                      {poateIncarca ? (
                        <button className="buton-mic" onClick={async () => {
                          try { await api.schimbaVizibilitatea(d.id, !d.vizibilClient); await reincarca(); }
                          catch (e) { setEroare(mesajEroare(e)); }
                        }}>
                          {d.vizibilClient ? tr("îl vede") : tr("ascuns")}
                        </button>
                      ) : d.vizibilClient ? tr("îl vede") : tr("ascuns")}
                    </td>
                    <td className="celula-actiuni">
                      <button className="buton-mic" onClick={() => descarca(d)}>{tr("descarcă")}</button>
                      {poateIncarca && d.esteCurenta && (
                        <button className="buton-mic" onClick={() => setForm({ inlocuieste: d })}>
                          {tr("versiune nouă")}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="nota-cautare">
              {tr("Coloana „Client\" spune dacă documentul ajunge în portalul clientului. Manualele și schemele sunt implicit ale lui; contractul, nu.")}
            </p>
          </div>
        </div>
      )}

      {form && (
        <FormDocument
          clientId={clientId}
          rubrici={rubrici.filter((r) => !r.generatDeAplicatie)}
          inlocuieste={form.inlocuieste}
          inchide={() => setForm(null)}
          gata={async () => { setForm(null); await reincarca(); }}
        />
      )}

      {istoric && (
        <div className="modal-fundal" onClick={() => setIstoric(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{tr("Istoricul documentului")}</h2>
            <p className="subtitlu">
              {tr("Versiunile vechi rămân accesibile. Amprenta răspunde la „e același fișier pe care l-am primit atunci?\".")}
            </p>
            <table className="tabel">
              <thead><tr><th>{tr("Versiune")}</th><th>{tr("Denumire")}</th><th>{tr("Încărcat")}</th><th>{tr("Amprentă")}</th><th></th></tr></thead>
              <tbody>
                {istoric.map((v) => (
                  <tr key={v.id} className={v.esteCurenta ? "" : "tip-dezactivat"}>
                    <td className="num">{tr("v")}{v.versiune}{v.esteCurenta && <span className="marcaj">{tr("curentă")}</span>}</td>
                    <td className="tip-denumire">{tr(v.denumire)}</td>
                    <td>{data(v.incarcatLa)}</td>
                    <td><code className="cod-mic">{(v.hashSHA256 || "").slice(0, 12)}…</code></td>
                    <td className="celula-actiuni">
                      <button className="buton-mic" onClick={() => descarca(v)}>{tr("descarcă")}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="modal-actiuni">
              <button className="buton buton-discret" onClick={() => setIstoric(null)}>{tr("închide")}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function FormDocument({ clientId, rubrici, inlocuieste, inchide, gata }) {
  const [categorieId, setCategorieId] = useState(inlocuieste?.categorie?.id ?? "");
  const [denumire, setDenumire] = useState("");
  const [fisier, setFisier] = useState(null);
  const [vizibilClient, setVizibilClient] = useState(inlocuieste?.vizibilClient ?? null);
  const [eroare, setEroare] = useState("");
  const [salvez, setSalvez] = useState(false);

  const alege = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 15 * 1024 * 1024) {
      setEroare(tr("Fișierul are {0} MB; limita e 15 MB.", (f.size / 1024 / 1024).toFixed(1)));
      return;
    }
    setEroare("");
    setFisier(f);
    if (!denumire) setDenumire(f.name);
  };

  const salveaza = async () => {
    if (!fisier) return;
    setSalvez(true); setEroare("");
    try {
      const base64 = await new Promise((rez, resp) => {
        const c = new FileReader();
        c.onload = () => rez(String(c.result));
        c.onerror = () => resp(new Error("Fișierul nu a putut fi citit."));
        c.readAsDataURL(fisier);
      });
      await api.incarcaDocument(clientId, {
        categorieId,
        denumire: denumire.trim() || fisier.name,
        continutBase64: base64,
        mimeType: fisier.type || undefined,
        ...(vizibilClient === null ? {} : { vizibilClient }),
        ...(inlocuieste ? { inlocuiesteId: inlocuieste.id } : {}),
      });
      await gata();
    } catch (e) { setEroare(mesajEroare(e)); setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{inlocuieste ? tr("Versiune nouă") : tr("Document nou")}</h2>
        {inlocuieste && (
          <p className="subtitlu">
            {tr("Înlocuiește „")}{tr(inlocuieste.denumire)}{tr("\" (v")}{inlocuieste.versiune}{tr("). Cea veche rămâne în dosar, marcată ca versiune anterioară.")}
          </p>
        )}
        {eroare && <div className="eroare">{eroare}</div>}

        <label>{tr("Rubrică")}
          <select className="camp" value={categorieId} disabled={!!inlocuieste}
            onChange={(e) => setCategorieId(e.target.value)}>
            <option value="">{tr("— alege —")}</option>
            {rubrici.map((r) => <option key={r.id} value={r.id}>{tr(r.denumire)}</option>)}
          </select>
        </label>
        <label>{tr("Fișier")}
          <input className="camp" type="file" onChange={alege} />
        </label>
        <label>{tr("Denumire")}<input className="camp" value={denumire}
          onChange={(e) => setDenumire(e.target.value)} /></label>
        <label className="linie-bifa">
          <input type="checkbox"
            checked={vizibilClient ?? rubrici.find((r) => r.id === categorieId)?.vizibilImplicitClient ?? false}
            onChange={(e) => setVizibilClient(e.target.checked)} />
          {tr("clientul poate vedea acest document")}
        </label>
        <p className="nota-cautare">
          {tr("Bifa pornește de la ce e obișnuit pentru rubrica aleasă, dar decizia rămâne pe fiecare document.")}
        </p>

        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide} disabled={salvez}>{tr("renunță")}</button>
          <button className="buton buton-adauga" onClick={salveaza}
            disabled={!categorieId || !fisier || salvez}>
            {salvez ? tr("se încarcă…") : tr("încarcă")}
          </button>
        </div>
      </div>
    </div>
  );
}
